import { ref } from 'vue'

const selectedPackageItemId = ref(null)
const setSelectedPackageItemId = (singleCreditPriceId) =>
  (selectedPackageItemId.value = singleCreditPriceId)

const setState = (packagePriceId) => {
  setSelectedPackageItemId(packagePriceId)
}

const clearState = () => {
  selectedPackageItemId.value = null
}

export { selectedPackageItemId, setSelectedPackageItemId, setState, clearState }
